const deps = [];

function UserProfile(
	$window
) {
	const service = this;

	service.setUserProfile = setUserProfile;
	service.getUserProfile = getUserProfile;
	service.setUser = setUser;
	service.clear = clear;
	service.getUser = getUser;

	function setUser(user) {
		service.user = user;
	}

	function clear() {
		service.user = null;
		service.allProfiles = null;
	}

	function getUser() {
		return service.user;
	}

	function setUserProfile(profile) {
		if(service.user && service.user.userId) {
			service.allProfiles[service.user.userId] = profile;
			$window.localStorage.setItem("profile", angular.toJson(service.allProfiles));
		}
	}

	function getUserProfile() {
		if(service.user && service.user.userId) {
			if(!service.allProfiles) {
				service.allProfiles = angular.fromJson($window.localStorage.getItem("profile")) || {};
				$window.localStorage.setItem("profile", angular.toJson(service.allProfiles));
			}

			if(!service.allProfiles[service.user.userId]) {
				service.allProfiles[service.user.userId] = {};
				$window.localStorage.setItem("profile", angular.toJson(service.allProfiles));
			}

			const thisUserId = service.user.userId;
			return service.allProfiles[thisUserId];
		}

		return null;
	}

	return service;
}
export default angular
	.module("vesl.services.user-profile", deps)
	.service("$userProfile", UserProfile).name;
